import keyBy from 'lodash-es/keyBy';
import { ProductsActionKeys as keys } from './productsActionKeys';
import { ProductsActionTypes } from './productsActionTypes';
import { IProduct } from './productsInterfaces';

export interface IProductsState {
  productHash: { [index: string]: IProduct };
}

const initState: IProductsState = {
  productHash: {}
};

export function productsReducer(state: IProductsState = initState, action: ProductsActionTypes): IProductsState {
  switch (action.type) {
    case keys.SET_PRODUCTS:
      return {
        ...state,
        productHash: {
          ...state.productHash,
          ...keyBy(action.payload, (x: IProduct) => x.itemId)
        }
      };
    default:
      return state;
  }
}
